/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Detail_Audience_EyebrowInputs */

const en_directory_taxonomy_detail_audience_eyebrow = /** @type {(inputs: Directory_Taxonomy_Detail_Audience_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse by audience`)
};

const zh_directory_taxonomy_detail_audience_eyebrow = /** @type {(inputs: Directory_Taxonomy_Detail_Audience_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按受众浏览`)
};

/**
* | output |
* | --- |
* | "Browse by audience" |
*
* @param {Directory_Taxonomy_Detail_Audience_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_detail_audience_eyebrow = /** @type {((inputs?: Directory_Taxonomy_Detail_Audience_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Detail_Audience_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_detail_audience_eyebrow(inputs)
	return zh_directory_taxonomy_detail_audience_eyebrow(inputs)
});
export { directory_taxonomy_detail_audience_eyebrow as "directory.taxonomy_detail.audience.eyebrow" }